/**
 * Formatting page slug to remove the leading slash.
 * Page Slug comes from Facade and includes the leading slash to follow the proposal. However,
 * there are dashboards that rely on the current format of pageSlug (without the leading slash).
 *
 * Keeping this until the dashboards are updated.
 */
export const formatPageSlug = (pageSlug: string): string => {
  if (pageSlug === '/') {
    return pageSlug
  }
  return pageSlug.replaceAll(/^\//g, '')
}
